import React, { useState } from 'react';
import axios from 'axios';
import GreenTick from '../../../../src/pages/client/client_assets/img/green_tick.svg';
import mail_svg from '../../../../src/pages/client/client_assets/img/mail.svg';
import '../../../../src/pages/client/client_assets/css/common.css';
import config from '../../../config/config';

const ForgotPasswordForm = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post('https://api.skepper.in/forgot-password.php', {
                email
            });

            if (response.data.success) {
                setSuccess(true);
                setMessage('A reset link has been sent to your email address.');
            } else {
                setSuccess(false);
                setMessage(response.data.message || 'Error occurred. Please try again.');
            }
        } catch (error) {
            setSuccess(false);
            setMessage('Something went wrong. Please try again later.');
        }
    };

    return (
        <div className="forgot-password-form-content">
            <h1 className="forgot-password-heading">Forgot password?</h1>
            <p className="forgot-password-text black_txt">
                Provide the email address affiliated with your account, 
                and we’ll send you a link to reset your password.
            </p>
            <form onSubmit={handleSubmit}>
                <div className="form-group email-group">
                    <img src={mail_svg} className='email_icon' />
                    <label htmlFor="email" className='black_txt'>Email Address</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder=""
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <button type="submit" className="forgot-password-button mt-5">Request Password Reset</button>
            </form>
          
            {message && (
                success ? (
                    <div className="we_sent">
                        <span><img src={GreenTick} alt="Success" /></span>
                        <p>{message}</p>
                    </div>
                ) : (
                    <div className='error_msg text-left'>
                        <h6>Email Not Found</h6>
                        <p>{message}</p>
                    </div>
                )
            )}
        </div>
    );
};

export default ForgotPasswordForm;
